export const getScoreColor = (score: number, light: boolean): string => {
  if (light) {
    if (score >= 0.8) return `hsl(120,100%,87%)`;
    if (score >= 0.6) return `hsl(80,95%,85%)`;
    if (score >= 0.4) return `hsl(60,90%,82%)`;
    if (score >= 0.2) return `hsl(45,95%,85%)`;
    /*             */ return `hsl(0,100%,94%)`;
  } else {
    if (score >= 0.8) return `hsl(120,90%,45%)`;
    if (score >= 0.6) return `hsl(75,95%,45%)`;
    if (score >= 0.4) return `hsl(60,100%,45%)`;
    if (score >= 0.2) return `hsl(40,90%,50%)`;
    /*             */ return `hsl(0,80%,55%)`;
  }
};
